import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './controleRouteIdForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';
import readXlsxFile from 'read-excel-file/web-worker'
import Excel from '../common/excel/excel';

import { 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, importar, baixarModelo
} from './controleRouteIdActions';
import { setError } from '../common/toast/toast';

const columns = [{
    field: 'codigo',
    type: 'text'
}, {
    field: 'id_tabela_frete_vigencia',
    type: 'text'
}, {
    field: 'id_tabela_frete_rota',
    type: 'text'
}, {
    field: 'id_rota',
    type: 'text'
}, {
    field: 'servico',
    type: 'text'
}, {
    field: 'tipo_veiculo',
    type: 'text'
}, {
    field: 'nome_natureza',
    type: 'text'
}, {
	field: 'descricao_tabela_frete',
	type: 'text'
}, {
    field: 'data_inicio_vigencia',
    type: 'date'
}, {
    field: 'data_fim_vigencia',
    type: 'date'
}];

class ControleRouteId extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'nome',
			direction: 'asc'
		},
		paginaAtual: 1,
		linhasPorPagina: 100
	}

	componentDidMount() {

		const fileSelectorImportar = document.createElement('input');
		fileSelectorImportar.setAttribute('type', 'file');
		fileSelectorImportar.addEventListener("change", async (data) => {

			let reader = new FileReader();
			let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
			if (!file) {
				file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
			}

			if (file) {

				if (!file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
					|| (file.type.includes('application/excel') || file.type.includes('application/vnd.ms-excel'))) {
					setError('Selecione apenas (.XLSX)');
					return;
				}

				let tabela = [];
				await readXlsxFile(file, { sheet: 1 }).then((rows) => {
					tabela = rows;
				});

				this.props.importar(tabela);

				reader.readAsDataURL(file);

			}
		});

		this.fileSelectorImportar = fileSelectorImportar;
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
		)
	}

	filtrar() {

		const filtroVigencia = this.props.filtro.vigencia ? JSON.parse(this.props.filtro.vigencia) : null;

		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(p => p.trim())
					.some(pesquisar => `
						${item.codigo}
						${item.id_tabela_frete_vigencia}
						${item.id_tabela_frete_rota}
						${item.id_rota}
						${item.servico}
						${item.tipo_veiculo}
						${item.nome_natureza}
						${item.descricao_tabela_frete}
						${DateFormat.formatarDataSqlParaTela(item.data_inicio_vigencia)}
						${DateFormat.formatarDataSqlParaTela(item.data_fim_vigencia)}
					`.toUpperCase().includes(pesquisar.trim())
					);
		}).filter(item => {
			if (this.props.filtro.status) {
				if (this.props.filtro.status == 'vinculado' && !item.codigo) {
					return false;
				} else if (this.props.filtro.status == 'nao_vinculado' && item.codigo) {
					return false;
				}
			}
			if (filtroVigencia && (
				filtroVigencia.data_inicio_vigencia != item.data_inicio_vigencia
				|| filtroVigencia.data_fim_vigencia != item.data_fim_vigencia
			)) {
				return false;
			}

			return true;
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}

	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.filtrar();

		let mapa = new Map();

		this.props.lista.forEach(item => {
			const chave = JSON.stringify({ data_inicio_vigencia: item.data_inicio_vigencia, data_fim_vigencia: item.data_fim_vigencia });

			if (!mapa.has(chave)) {
				mapa.set(chave, {
					chave: chave,
					data_inicio_vigencia: item.data_inicio_vigencia,
					data_fim_vigencia: item.data_fim_vigencia
				});
			}
		});

		let listaVigencias = Array.from(mapa.values());
		listaVigencias.sort((a, b) => a.data_inicio_vigencia <= b.data_inicio_vigencia ? -1 : 1);

		const { paginaAtual, linhasPorPagina } = this.state; 
		const totalPaginas = Math.ceil(lista.length / linhasPorPagina) || 1; 
		const inicio = (paginaAtual - 1) * linhasPorPagina; 
		const fim = inicio + linhasPorPagina; 
		const listaPaginada = lista.slice(inicio, fim);

		const height = window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
			window.innerWidth < 1093 ? `${window.innerHeight - 340}px`
				: (
					window.innerWidth < 1799
						? `${window.innerHeight - 220}px`
						: (
							window.innerWidth < 4000
								? `${window.innerHeight - 220}px`
								: `${window.innerHeight - 150}px`
						)
				)
		);

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, pesquisar: value });

								this.setState({
									paginaAtual: 1
								});
							}} />

						<Select
							options={[{ id: 'vinculado', valor: 'Vinculado'}, { id: 'nao_vinculado', valor: 'Não Vinculado'}, { id: 'ambos', valor: 'Ambos'}]}
							label='Status'
							cols='12 1 1 1'
							minWidth={200}
							placeholder='Selecione'
							value={this.props.filtro.status}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									status: value
								});
								
								this.setState({
									paginaAtual: 1
								});
							}} />
					
						<Select
							options={listaVigencias.map(item => ({ id: item.chave, valor: `${DateFormat.formatarDataSqlParaTela(item.data_inicio_vigencia)} - ${DateFormat.formatarDataSqlParaTela(item.data_fim_vigencia)}` }))}
							label='Vigência'
							cols='12 1 1 1'
							minWidth={300}
							placeholder='Selecione'
							value={this.props.filtro.vigencia}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									vigencia: value
								});

								this.setState({
									paginaAtual: 1
								});
							}} />
							
						<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();

									this.setState({
										paginaAtual: 1
									});
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							{/*<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>*/}

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.fileSelectorImportar.click();
									this.setState({
										paginaAtual: 1
									});
								}}>
								<i class='fas fa-file-excel'></i> Importar
							</a>

							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.baixarModelo();
								}}>
								<i class='fas fa-file-excel'></i> Modelo
							</a>

							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.montarExcel(lista);
								}}>
								<i class='fas fa-file-excel'></i> Exportar
							</a>

						</div>
					</Row>

					<div 
						style={{ 
							minHeight: height
						}}>
						<Table responsive border striped alturaFixa
							maxHeight={height}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									
									<ThSort
										field='codigo'
										label='Código'
										width={200}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='id_tabela_frete_vigencia'
										label='ID Vigência'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='id_tabela_frete_rota'
										label='ID Tabela Frete'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='id_rota'
										label='ID Rota'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />
									
									<ThSort
										field='num_rota_cliente'
										label='Num Rota Cliente'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='servico'
										label='Serviço'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='tipo_veiculo'
										label='Tipo de Veículo'
										width={100}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='nome_natureza'
										label='Natureza'
										width={100}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='descricao_tabela_frete'
										label='Descrição Tabela Frete'
										width={200}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='data_inicio_vigencia'
										label='Início de Vigência'
										width={100}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='data_fim_vigencia'
										label='Fim de Vigência'
										width={100}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />									

									<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} width={50} alignCenter></Th>
								</Tr>
							</THead>
							<TBody>
								{listaPaginada.map((item, i) => (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td color={'#000'} alignCenter small>{item.codigo}</Td>
										<Td color={'#000'} alignCenter small>{item.id_tabela_frete_vigencia}</Td>
										<Td color={'#000'} alignCenter small>{item.id_tabela_frete_rota}</Td>
										<Td color={'#000'} alignCenter small>{item.id_rota}</Td>
										<Td color={'#000'} alignCenter small>{item.num_rota_cliente}</Td>
										<Td color={'#000'} alignCenter small>{item.servico}</Td>
										<Td color={'#000'} alignCenter small>{item.tipo_veiculo}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_natureza}</Td>
										<Td color={'#000'} alignCenter small>{item.descricao_tabela_frete}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_inicio_vigencia)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_fim_vigencia)}</Td>
										<Td minWidth={50} width={50} alignCenter>
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
						<div><strong>{lista.length}</strong> registros</div>
						<div style={{ display: 'flex', gap: 5 }}>
							<button className='btn btn-light' disabled={paginaAtual === 1} 
								onClick={() => this.setState({ paginaAtual: 1 })}>
								<i class='fas fa-angle-double-left'></i>
							</button>
							<button className='btn btn-light' disabled={paginaAtual === 1} 
								onClick={() => this.setState({ paginaAtual: paginaAtual - 1 })}>
								<i class='fas fa-angle-left'></i>
							</button>
							<span style={{ padding: '6px 12px', display: 'flex' }}>
								<div style={{ width: 30, textAlign: 'center' }}>{paginaAtual}</div> de <div style={{ width: 30, textAlign: 'center' }}>{totalPaginas}</div>
							</span>
							<button className='btn btn-light' disabled={paginaAtual >= totalPaginas}
								onClick={() => this.setState({ paginaAtual: paginaAtual + 1 })}>
								<i class='fas fa-angle-right'></i>
							</button>
							<button className='btn btn-light' disabled={paginaAtual >= totalPaginas}
								onClick={() => this.setState({ paginaAtual: totalPaginas })}>
								<i class='fas fa-angle-double-right'></i>
							</button>
						</div>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(listaFiltrada) {

		Excel.exportar('Controle Route ID',
			[{
				atributo: 'id',
				nome: 'id',
				largura: 10,
				formato: null
			}, {
				atributo: 'codigo',
				nome: 'codigo',
				largura: 40,
				formato: null
			}, {
				atributo: 'id_tabela_frete_vigencia',
				nome: 'id_tabela_frete_vigencia',
				largura: 20,
				formato: null
			}, {
				atributo: 'id_tabela_frete_rota',
				nome: 'id_tabela_frete_rota',
				largura: 20,
				formato: null
			}, {
				atributo: 'descricao_tabela_frete',
				nome: 'descricao_tabela_frete',
				largura: 20,
				formato: null
			}, {
				atributo: 'id_rota',
				nome: 'id_rota',
				largura: 20,
				formato: null
			}, {
				atributo: 'servico',
				nome: 'servico',
				largura: 20,
				formato: null
			}, {
				atributo: 'id_classificacao_comercial',
				nome: 'id_classificacao_comercial',
				largura: 20,
				formato: null
			}, {
				atributo: 'tipo_veiculo',
				nome: 'tipo_veiculo',
				largura: 20,
				formato: null
			}, {
				atributo: 'id_natureza',
				nome: 'id_natureza',
				largura: 20,
				formato: null
			}, {
				atributo: 'nome_natureza',
				nome: 'nome_natureza',
				largura: 20,
				formato: null
			}, {
				atributo: 'descricao_tabela_frete',
				nome: 'descricao_tabela_frete',
				largura: 20,
				formato: null
			}, {
				atributo: 'num_rota_cliente',
				nome: 'num_rota_cliente',
				largura: 20,
				formato: null
			}, {
				atributo: 'data_inicio_vigencia',
				nome: 'data_inicio_vigencia',
				largura: 20,
				formato: Excel.FORMATOS.data
			}, {
				atributo: 'data_fim_vigencia',
				nome: 'data_fim_vigencia',
				largura: 20,
				formato: Excel.FORMATOS.data
			}],
			listaFiltrada.map(item => ({
				...item
			}))
		);
	}	

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.controleRouteId.aguardando,
	modoTela: state.controleRouteId.modoTela,
	lista: state.controleRouteId.lista,
	filtro: state.controleRouteId.filtro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, importar, baixarModelo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControleRouteId);
